/*
 * @Date: 2025-01-22 10:53:18
 * @LastEditors: furan NgeKaworu@gmail.com
 * @LastEditTime: 2025-05-20 15:30:50
 * @FilePath: /newwork-h5/src/utils/i18n.js
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import request from '@/utils/request'
import { Locale } from 'vant'
import dayjs from 'dayjs'
import { updateUserLanguage } from '@/services/api'
Vue.use(VueI18n)

import zh from '../../locales/zh-CN.json'
import en from '../../locales/en-US.json'

const TAG = '[i18n]'

export class LocaleMgr {
  constructor() {}

  static _instance = new LocaleMgr()

  static get singleton() {
    return LocaleMgr._instance
  }

  static get highestPriorityFirstLocale() {
    //优先级 URLParams > 用户 > 企业 > 客户机系统

    const usp = new URLSearchParams(window.location.search)

    const localLanguage = usp?.get('localLanguage')

    const userLanguage = localStorage.getItem('userLanguage')

    const enterpriseLanguage = localStorage.getItem('enterpriseLanguage')

    const highestPriorityLang =
      localLanguage || userLanguage || enterpriseLanguage || navigator.language || 'zh-CN'

    if (highestPriorityLang != userLanguage) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('user'))
        // 通过更新接口保证推送通知的语言与当前一致
        updateUserLanguage({ userId: userInfo.id, language: highestPriorityLang })
        localStorage.setItem('userLanguage', highestPriorityLang)
      } catch (e) {
        console.error(TAG, 'update user lang fail:', e)
      }
    }
    return highestPriorityLang
  }

  initialized = false
  project = 'newwork-h5'
  company = ''

  srv = ''

  async init(config) {
    if (!config?.company) throw new Error('invalid config')

    if (this.initialized) return true
    this.initialized = true
    try {
      this.company = config.company

      this.srv = await this.fetchSrvPath()

      const locale = LocaleMgr.highestPriorityFirstLocale
      console.log(TAG, `locale: ${locale}`)

      await this.setLocale(locale)
    } catch (e) {
      console.error(TAG, 'init error: ', e)
      this.initialized = false
    }
  }

  async fetchSrvPath() {
    // const {protocol, host, port} = await request.get('api');
    // const protocol = 'http://'
    // const host = '192.168.188.47'
    // const port = ':6868'
    // // 协议://主机名[:端口]
    // return `${protocol}${host}${port}`

    const LANG_SERV_URL = process.env.VUE_APP_LANG_SERV_URL
    return `${LANG_SERV_URL}/multi_languages`
  }

  async setLocale(locale = LocaleMgr.highestPriorityFirstLocale) {
    try {
      if (!this.initialized) return

      // /公司名/语言名/frontend/项目名.json
      const path = `/${this.company}/${locale}/frontend/${this.project}.json`

      // 远程路径 服务器/path
      const uri = `${this.srv}${path}`

      const data = await request.get(uri)

      i18n.setLocaleMessage(locale, data)
    } catch (e) {
      console.log(TAG, 'setLocale error: ', e)
      console.log(TAG, 'setLocale error: ', e?.message)
    } finally {
      i18n.locale = locale

      document.querySelector('html').setAttribute('lang', locale)
      import(`vant/es/locale/lang/${locale}`)
        .then(({ default: messages }) => Locale.use(locale, messages))
        .catch(e => {
          console.error('[i18n]', 'can not change vant locate, e: ', e, 'fallback to chinese')
        })
      dayjs.locale(locale)

      return locale
    }
  }
}

const i18n = new VueI18n({
  locale: LocaleMgr.highestPriorityFirstLocale,
  // 默认语言
  messages: {
    'zh-CN': zh, // 中文
    'en-US': en, // 英文
  },
})

export default i18n

// 冗余兼容的代码。
// 兼容1：访客创建类型，类型保存时直接用的中文。因为国际化后则用的是不同的国际化语言，传参时就有问题：例如中文状态下传的是拜访， 但英文状态下是Call on。需要兼容。其他语言也需要手动维护兼容
export const I18nTemplateForSubmit = {
  拜访: '拜访',
  面试: '面试',
  商务合作: '商务合作',
  考察: '考察',
  其他: '其他',
  'Call on': '拜访',
  interview: '面试',
  'Business cooperation': '商务合作',
  investigate: '考察',
  other: '其他',
}

export const I18nTemplateForRender = key => {
  const currLanguage = i18n.locale // 获取当前使用的语言

  const languageTemplate = {
    'zh-CN': {
      拜访: '拜访',
      面试: '面试',
      商务合作: '商务合作',
      考察: '考察',
      其他: '其他',

      //冗余：兼容历史数据
      'Call on': '拜访',
      interview: '面试',
      'Business cooperation': '商务合作',
      investigate: '考察',
      other: '其他',
    },
    'en-US': {
      'Call on': 'Call on',
      interview: 'interview',
      'Business cooperation': 'Business cooperation',
      investigate: 'investigate',
      other: 'other',

      //冗余：兼容历史数据
      拜访: 'Call on',
      面试: 'interview',
      商务合作: 'Business cooperation',
      考察: 'investigate',
      其他: 'other',
    },
  }

  return languageTemplate?.[currLanguage]?.[key]
}

